import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Koregaonparktomumbaicabs() {



  const cardData = {


  keyword: "Koregaon Park to Mumbai Cabs",

  headingDescription: "Trustline Travels offers premium Koregaon Park to Mumbai cab services with safe, comfortable, and reliable transportation for corporate travel, airport transfers, business meetings, family trips, and outstation journeys. Whether you need a one-way taxi or a round-trip cab, our professional chauffeurs ensure timely pickups and a smooth travel experience. Our fleet includes AC Sedans, SUVs, Innova Crysta, Ertiga, Tempo Travellers, and luxury cars to meet different travel needs. With transparent pricing, doorstep pickup, easy online booking, and 24/7 customer support, Trustline Travels is the trusted choice for Koregaon Park to Mumbai taxi services.",

  topPlaces: [
    {
      title: "One International Center",
      description: "One International Center in Lower Parel is a premium corporate destination featuring modern office spaces, multinational companies, and leading business establishments."
    },
    {
      title: "Hiranandani Business Park",
      description: "Hiranandani Business Park in Powai is a major commercial hub with IT companies, corporate offices, startups, and modern business facilities."
    },
    {
      title: "NESCO Business Centre",
      description: "NESCO Business Centre in Goregaon hosts corporate exhibitions, trade fairs, conferences, and professional business events throughout the year."
    },
    {
      title: "Airoli IT Park",
      description: "Airoli IT Park is a growing technology hub in Navi Mumbai, home to global IT companies, software firms, and corporate campuses."
    },
    {
      title: "Rabale MIDC",
      description: "Rabale MIDC is an important industrial and commercial zone with manufacturing units, technology companies, and business establishments."
    },
    {
      title: "Goregaon Business District",
      description: "Goregaon Business District is a developing commercial area with corporate offices, IT companies, exhibition centers, and business parks."
    },
    {
      title: "Siddhivinayak Temple",
      description: "Siddhivinayak Temple is one of Mumbai's most famous religious destinations, attracting thousands of devotees throughout the year."
    },
    {
      title: "Marine Drive",
      description: "Marine Drive is a beautiful coastal promenade known for stunning sea views, evening walks, and Mumbai's famous Queen's Necklace skyline."
    },
    {
      title: "Bandra Fort",
      description: "Bandra Fort offers scenic views of the Arabian Sea and Bandra-Worli Sea Link, making it a popular sightseeing location."
    },
    {
      title: "Global Vipassana Pagoda",
      description: "Global Vipassana Pagoda is a peaceful meditation monument known for its grand architecture and serene surroundings near Gorai."
    }
  ],





"services": [
  {
    "name": "Koregaon Park to Mumbai Cab",
    "description": "Book Koregaon Park to Mumbai cab for safe and comfortable intercity travel with Sedan, Ertiga, Innova Crysta, SUV, and luxury vehicles. Enjoy doorstep pickup, professional chauffeurs, transparent pricing, and reliable one-way, round-trip, airport, corporate, and family travel services available 24x7."
  },
  {
    "name": "Koregaon Park to Mumbai Airport Cab",
    "description": "Reserve Koregaon Park to Mumbai Airport cab for timely airport transfers with flight tracking, luggage assistance, professional drivers, and comfortable AC vehicles for domestic and international airport travel."
  },
  {
    "name": "Koregaon Park to Mumbai International Airport Cab",
    "description": "Book Koregaon Park to Mumbai International Airport cab for direct transfers to Chhatrapati Shivaji Maharaj International Airport with reliable pickup, premium vehicles, and experienced chauffeurs."
  },
  {
    "name": "Koregaon Park to Mumbai Airport Drop Taxi",
    "description": "Get Koregaon Park to Mumbai Airport drop taxi service with affordable pricing, punctual pickup, direct airport routes, luggage support, and comfortable chauffeur-driven cars."
  },
  {
    "name": "Koregaon Park to Mumbai Airport One Way Taxi",
    "description": "Book Koregaon Park to Mumbai Airport one way taxi and pay only for your single journey. Ideal for business travelers, families, and airport passengers looking for affordable travel."
  },
  {
    "name": "Koregaon Park to Mumbai Round Trip",
    "description": "Koregaon Park to Mumbai round trip cab service offers flexible return schedules for business visits, meetings, sightseeing, and family travel with comfortable AC vehicles."
  },
  {
    "name": "Cab Service in Koregaon Park",
    "description": "Professional cab service in Koregaon Park for local rides, airport transfers, corporate travel, outstation journeys, and Mumbai travel with Sedan, Ertiga, Innova Crysta, SUVs, and luxury cars."
  },
  {
    "name": "Koregaon Park to Santacruz Cab Fare",
    "description": "Check Koregaon Park to Santacruz cab fare with transparent pricing for airport transfers, business trips, and personal travel with multiple vehicle options."
  },
  {
    "name": "Koregaon Park to Mumbai Central Cab",
    "description": "Book Koregaon Park to Mumbai Central cab for railway station transfers, business meetings, and city travel with experienced drivers and comfortable vehicles."
  },
  {
    "name": "Pune to Mumbai Airport Cab",
    "description": "Book Pune to Mumbai Airport cab with direct transfers to domestic and international terminals. Enjoy punctual pickup, comfortable AC vehicles, and professional chauffeur service."
  },
  {
    "name": "Pune to Mumbai Ertiga Cab",
    "description": "Choose Pune to Mumbai Ertiga cab for spacious family travel, airport transfers, and group transportation with affordable fares and experienced drivers."
  },
  {
    "name": "Pune to Mumbai Innova Cab",
    "description": "Premium Pune to Mumbai Innova cab service provides luxury seating, extra luggage capacity, smooth highway travel, and professional chauffeurs for business and family journeys."
  },
  {
    "name": "Koregaon Park to Navi Mumbai Cab",
    "description": "Reliable Koregaon Park to Navi Mumbai cab service for corporate travel, airport transfers, business meetings, and family trips with clean AC vehicles."
  },
  {
    "name": "Koregaon Park to Airport Cab Service",
    "description": "Book Koregaon Park to airport cab service with timely pickup, flight monitoring, luggage assistance, and affordable airport transfer packages."
  },
  {
    "name": "Koregaon Park to Thane Cab Service",
    "description": "Reserve Koregaon Park to Thane cab service for business travel, personal visits, and outstation journeys with professional chauffeurs and comfortable cars."
  },
  {
    "name": "Koregaon Park to Mumbai Airport Innova",
    "description": "Book Koregaon Park to Mumbai Airport Innova for premium airport travel with spacious seating, luggage space, and luxury comfort."
  },
  {
    "name": "Innova Crysta on Rent in Koregaon Park",
    "description": "Hire Innova Crysta on rent in Koregaon Park for Mumbai travel, airport transfers, family vacations, corporate meetings, and premium outstation journeys."
  },
  {
    "name": "7 Seater Car on Rent in Koregaon Park",
    "description": "Book 7 seater car on rent in Koregaon Park for family trips, group travel, airport transfers, and comfortable long-distance journeys with professional drivers."
  },
  {
    "name": "Ertiga on Rent in Koregaon Park",
    "description": "Rent Ertiga in Koregaon Park for family travel, Mumbai trips, airport transfers, and group transportation with affordable pricing and reliable service."
  },
  {
    "name": "Luxury Car on Rent in Koregaon Park",
    "description": "Luxury car rental in Koregaon Park offers premium vehicles for corporate events, airport transfers, business meetings, and special occasions with chauffeur service."
  },
  {
    "name": "Pune Mumbai Velocity Cabs",
    "description": "Pune Mumbai Velocity Cabs provides reliable one-way, airport transfer, corporate, and round-trip taxi services with premium vehicles and transparent pricing."
  },
  {
    "name": "Cab Service in Pune",
    "description": "Professional cab service in Pune for local transportation, airport transfers, corporate travel, and outstation journeys with multiple vehicle options."
  },
  {
    "name": "Pune Mumbai Cab",
    "description": "Reliable Pune Mumbai cab service for airport transfers, business travel, sightseeing, family trips, and one-way or round-trip journeys."
  },
  {
    "name": "Cab Service in Koregaon Park",
    "description": "Trusted cab service in Koregaon Park offering local rides, airport transfers, Mumbai travel, corporate transportation, and outstation taxi services."
  },
  {
    "name": "Koregaon Park to Mumbai Taxi",
    "description": "Book Koregaon Park to Mumbai taxi with professional drivers, comfortable AC vehicles, fixed pricing, and reliable transportation for every travel need."
  },
  {
    "name": "Koregaon Park to Mumbai Cab Service",
    "description": "Choose Koregaon Park to Mumbai cab service for airport transfers, business trips, family travel, and one-way journeys with transparent pricing."
  },
  {
    "name": "Koregaon Park to Mumbai Taxi Service",
    "description": "Our Koregaon Park to Mumbai taxi service provides safe, comfortable, and dependable travel with experienced chauffeurs and multiple vehicle categories."
  },
  {
    "name": "Koregaon Park to Mumbai Cab Booking",
    "description": "Book Koregaon Park to Mumbai cab online with instant confirmation, flexible pickup timing, secure booking, and 24x7 customer support."
  },
  {
    "name": "Cab from Koregaon Park to Mumbai",
    "description": "Reserve a cab from Koregaon Park to Mumbai for airport transfers, business meetings, sightseeing, and family trips with professional chauffeurs."
  },
  {
    "name": "Koregaon Park to Mumbai Car Rental",
    "description": "Koregaon Park to Mumbai car rental offers one-way, round-trip, airport, and corporate travel packages with Sedan, Ertiga, Innova Crysta, SUVs, and luxury vehicles."
  },
  {
    "name": "Koregaon Park to Mumbai One Way Cab",
    "description": "Book Koregaon Park to Mumbai one way cab and pay only for your single trip. Suitable for airport drops, business travel, and personal transportation."
  },
  {
    "name": "Cheap Koregaon Park to Mumbai Cab",
    "description": "Affordable Koregaon Park to Mumbai cab service with clean AC vehicles, experienced chauffeurs, transparent pricing, and reliable intercity travel."
  },
  {
    "name": "Koregaon Park to Mumbai Taxi Fare",
    "description": "Check Koregaon Park to Mumbai taxi fare with affordable pricing for Sedan, Ertiga, Innova Crysta, SUVs, and premium cars."
  },
  {
    "name": "Book Koregaon Park to Mumbai Cab Online",
    "description": "Book Koregaon Park to Mumbai cab online with instant confirmation, easy reservations, professional drivers, and multiple vehicle choices."
  },
  {
    "name": "Koregaon Park to Mumbai Outstation Cab",
    "description": "Reliable Koregaon Park to Mumbai outstation cab service for long-distance travel with experienced drivers, comfortable vehicles, and flexible pickup schedules."
  },
  {
    "name": "24x7 Koregaon Park to Mumbai Taxi Service",
    "description": "Our 24x7 Koregaon Park to Mumbai taxi service is available round the clock for airport transfers, emergency travel, business meetings, and family trips."
  },
  {
    "name": "Best Koregaon Park to Mumbai Cab Service",
    "description": "Experience the best Koregaon Park to Mumbai cab service with premium vehicles, professional chauffeurs, transparent pricing, instant booking, and reliable customer support."
  }
],

"tableData": [
  ["Koregaon Park to Mumbai Cab", "Koregaon Park to Mumbai Airport Cab"],
  ["Koregaon Park to Mumbai International Airport Cab", "Koregaon Park to Mumbai Airport Drop Taxi"],
  ["Koregaon Park to Mumbai Airport One Way Taxi", "Koregaon Park to Mumbai Round Trip"],
  ["Cab Service in Koregaon Park", "Koregaon Park to Santacruz Cab Fare"],
  ["Koregaon Park to Mumbai Central Cab", "Pune to Mumbai Airport Cab"],
  ["Pune to Mumbai Ertiga Cab", "Pune to Mumbai Innova Cab"],
  ["Koregaon Park to Navi Mumbai Cab", "Koregaon Park to Airport Cab Service"],
  ["Koregaon Park to Thane Cab Service", "Koregaon Park to Mumbai Airport Innova"],
  ["Innova Crysta on Rent in Koregaon Park", "7 Seater Car on Rent in Koregaon Park"],
  ["Ertiga on Rent in Koregaon Park", "Luxury Car on Rent in Koregaon Park"],
  ["Pune Mumbai Velocity Cabs", "Cab Service in Pune"],
  ["Pune Mumbai Cab", "Koregaon Park to Mumbai Taxi"],
  ["Koregaon Park to Mumbai Cab Service", "Koregaon Park to Mumbai Taxi Service"],
  ["Koregaon Park to Mumbai Cab Booking", "Cab from Koregaon Park to Mumbai"],
  ["Koregaon Park to Mumbai Car Rental", "Koregaon Park to Mumbai One Way Cab"],
  ["Cheap Koregaon Park to Mumbai Cab", "Koregaon Park to Mumbai Taxi Fare"],
  ["Book Koregaon Park to Mumbai Cab Online", "Koregaon Park to Mumbai Outstation Cab"],
  ["24x7 Koregaon Park to Mumbai Taxi Service", "Best Koregaon Park to Mumbai Cab Service"]
],






whychoose: [
  {
    WhyChooseheading: "Reliable Koregaon Park to Mumbai Cab Service",
    WhyChoosedescription: "Trustline Travels offers comfortable and dependable cab services from Koregaon Park to Mumbai for business, airport, and personal travel."
  },
  {
    WhyChooseheading: "Premium Pickup Experience from Koregaon Park",
    WhyChoosedescription: "Get convenient doorstep pickup from Koregaon Park, Kalyani Nagar, Viman Nagar, Bund Garden, and nearby Pune locations."
  },
  {
    WhyChooseheading: "Experienced Drivers for Pune Mumbai Route",
    WhyChoosedescription: "Our professional chauffeurs are familiar with highway routes and ensure a safe, smooth, and timely journey."
  },
  {
    WhyChooseheading: "Transparent & Affordable Cab Pricing",
    WhyChoosedescription: "Enjoy clear fare details with competitive pricing and no hidden charges throughout your booking."
  },
  {
    WhyChooseheading: "Comfortable Vehicle Options",
    WhyChoosedescription: "Choose from Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers for a comfortable ride."
  },
  {
    WhyChooseheading: "One Way & Round Trip Availability",
    WhyChoosedescription: "Book flexible one-way cabs, return trips, or customized travel plans according to your schedule."
  },
  {
    WhyChooseheading: "Perfect for Airport & Corporate Travel",
    WhyChoosedescription: "Our services are ideal for Mumbai Airport transfers, office meetings, corporate visits, and family journeys."
  },
  {
    WhyChooseheading: "Quick Booking Support",
    WhyChoosedescription: "Receive instant quotations and fast booking confirmation with assistance from our dedicated support team."
  }
]

};

const faqData = [
  {
    question: "Does Trustline Cab provide Koregaon Park to Mumbai cab service?",
    answer: "Yes, Trustline Cab provides reliable cab services from Koregaon Park to Mumbai for one-way trips, round trips, airport transfers, and corporate travel."
  },
  {
    question: "Can I book a one-way cab from Koregaon Park to Mumbai?",
    answer: "Yes, we offer affordable one-way cab options for passengers who need convenient direct travel to Mumbai."
  },
  {
    question: "Which vehicles are available for Koregaon Park to Mumbai travel?",
    answer: "You can select from Sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers according to your requirements."
  },
  {
    question: "Do you provide pickup from nearby Koregaon Park areas?",
    answer: "Yes, pickup is available from Koregaon Park, Kalyani Nagar, Viman Nagar, Yerawada, Bund Garden, and nearby locations."
  },
  {
    question: "Can I book a cab from Koregaon Park to Mumbai Airport?",
    answer: "Yes, we provide direct airport transfer services from Koregaon Park to Mumbai Airport Terminal 1 and Terminal 2."
  },
  {
    question: "Are toll and parking charges included in the fare?",
    answer: "Toll charges, parking fees, and applicable taxes are generally charged separately unless included in your booking details."
  },
  {
    question: "Is the cab service available for late-night travel?",
    answer: "Yes, Trustline Cab provides 24/7 cab availability for early morning, daytime, and late-night journeys."
  },
  {
    question: "Can I reserve my cab before the travel date?",
    answer: "Yes, advance booking is recommended to secure your preferred vehicle and pickup timing."
  },
  {
    question: "Do you provide cabs for corporate professionals?",
    answer: "Yes, our Koregaon Park to Mumbai cab service is suitable for business meetings, office travel, and corporate requirements."
  },
  {
    question: "How can I book a Koregaon Park to Mumbai cab with Trustline Travels?",
    answer: "Share your pickup address, travel date, destination, and preferred vehicle to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rakesh Sharma",
    feedback: "Trustline Travels provided excellent service for my journey from Koregaon Park to Mumbai. The cab arrived on time, the driver was professional, and the ride was very comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Meenal Joshi",
    feedback: "We selected Trustline Travels for our family trip from Koregaon Park to Mumbai. The vehicle was spacious, the booking process was simple, and the overall experience was highly satisfying.",
    rating: 5
  }
];












  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Koregaon Park to Mumbai Cab Service",
  "image": "https://www.trustlinetravels.com/assets/images/koregaon-park-to-mumbai-cab.webp",
  "description": "Book Koregaon Park to Mumbai cab service for safe, comfortable, and affordable intercity travel. Trustline Travels offers one-way, round-trip, and airport taxi services with Sedan, Ertiga, SUV, Innova, Innova Crysta, and luxury cab options available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6345"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/koregaon-park-to-mumbai-cab"
  }
};







  return (
    <div>
<Helmet>
  <title>Koregaon Park to Mumbai Cab | Airport Taxi Service | +91 8087080034</title>

  <meta
    name="description"
    content="Book Koregaon Park to Mumbai cab service with Trustline Travels for reliable one-way, round-trip, and airport transfers. Choose Sedan, Ertiga, SUV, Innova, and Innova Crysta taxis with professional drivers available 24x7."
  />

  <meta
    name="keywords"
    content="koregaon park to mumbai airport cab, koregaon park to mumbai international airport cab, koregaon park to mumbai airport drop taxi, koregaon park to mumbai airport one way taxi, koregaon park to mumbai round trip, cab service in koregaon park, koregaon park to mumbai cab, koregaon park to mumbai taxi service, koregaon park to mumbai one way cab, koregaon park to mumbai innova cab, koregaon park to mumbai ertiga cab, koregaon park mumbai airport taxi, pune to mumbai cab from koregaon park"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/43.jpeg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Koregaonparktomumbaicabs;